import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GaranLogService } from 'src/app/core/garan-log.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-orders-amount-dialog',
  templateUrl: './orders-amount-dialog.component.html',
  styleUrls: ['./orders-amount-dialog.component.scss'],
})
export class OrdersAmountDialogComponent {
  order_amount: number;
  order_currency: string;
  is_amount_read_running: boolean = false;
  buyer_id?: string;

  constructor(
    private dialog_ref: MatDialogRef<OrdersAmountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private garan_log_service: GaranLogService,
    private utils_service: UtilsService,
  ) {
    this.order_amount = data.order_amount;
    this.order_currency = data.order_currency;
    this.buyer_id = data.buyer_id;
  }

  ngOnInit(): void {
    if (this.buyer_id) {
      this.createGaranLog(this.buyer_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  createGaranLog(buyer_id: string): void {
    const admin_email = this.utils_service.getProfileEmail();
    this.garan_log_service.create(buyer_id, admin_email).subscribe({
      next: () => {},
      error: () => {},
    });
  }
}
